import './Heading.css';


const Heading = ({ name }) => {

    return (
        <div className="Heading">
            {/* <div>{name}</div> */}
            {name}
        </div>
        // <h1>SHARK</h1>
    );
}

export default Heading;
